module.exports = __webpack_public_path__ + "static/media/pic-2.ffabecba.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_imagerecognition/pic-2.png
// module id = 530
// module chunks = 0